import type { HSLColor } from "../types/colors/HSLColor"
import type { RGBColor } from "../types/colors/RGBColor"

/**
 * Converts RGB color to HSL color
 * Assumes RGB values are in range 0-1
 */
export const RgbToHsl = (rgb: RGBColor): HSLColor => {
  const { a, b, g, r } = rgb

  // Find the maximum and minimum values to calculate saturation
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const delta = max - min

  // Calculate lightness
  const l = (max + min) / 2

  // Calculate saturation
  let s = 0
  if (delta !== 0) {
    s = delta / (1 - Math.abs(2 * l - 1))
  }

  // Calculate hue
  let h = 0
  if (delta !== 0) {
    if (max === r) {
      h = ((g - b) / delta) % 6
    } else if (max === g) {
      h = (b - r) / delta + 2
    } else {
      h = (r - g) / delta + 4
    }

    h = h * 60 // Convert to degrees
    if (h < 0) h += 360
  }

  return { a, h, l, s }
}
